// InvitedUsers.js
import React, { useState, useEffect } from 'react';
import axios from '../../api/axiosConfig';
import { getInitials, getAvatarColor } from '../../utils/avatar';

function InvitedUsers({ board, currentUser }) {
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get('/users');
        setAllUsers(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchUsers();
  }, []);

  const invitedUserIds = board.invited_users || [];
  const coAdmins = board.co_admins || [];
  return (
    <div className="invited-users">
      {invitedUserIds.map(userId => {
        const user = allUsers.find(u => u.id === userId);
        if (!user) return null;
        const roleLabel =
          board.admin === userId
            ? '(Admin)'
            : coAdmins.includes(userId)
            ? '(Co‑Admin)'
            : '';
        return (
          <div
            key={userId}
            className="avatar"
            style={{ background: getAvatarColor(user.id) }}
            title={`${user.name} ${roleLabel}`}
          >
            {getInitials(user.name)}
          </div>
        );
      })}
    </div>
  );
}

export default InvitedUsers;
